import React, { useEffect, useState } from "react";
import Radio from "../../form/Radio";
import Image from "../Image";
import StripeForm from "./StripeForm";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import Button from "../../form/Button";
import { addCardService, deleteCardService, fetchCardList } from "../../../service/stripeService";
import americanExpress from "../../../assets/images/cardicon/American Express.png";
import dinersClub from "../../../assets/images/cardicon/Diners Club.png";
import discover from "../../../assets/images/cardicon/Discover.png";
import elo from "../../../assets/images/cardicon/elo.png";
import hipercard from "../../../assets/images/cardicon/hipercard-29.png";
import jcb from "../../../assets/images/cardicon/JCB.png";
import masterCard from "../../../assets/images/cardicon/MasterCard.png";
import mnp from "../../../assets/images/cardicon/mnp.png";
import troy from "../../../assets/images/cardicon/troy.png";
import unionPay from "../../../assets/images/cardicon/UnionPay.png";
import visa from "../../../assets/images/cardicon/Visa.png";
import { toast } from "react-toastify";
import { appointmentLang, appointmentModalLang } from "../language";
import { useSelector } from "react-redux";
import DeleteModal from "../DeleteModal";
import { useNavigate } from "react-router-dom";
import { STRIPE_API_KEY } from "../../../config/host";

const Cards = ({ isToggle = true, setIsCardAvailable = () => { }, setSelectedCard = () => { }, selectedCard = null, from = "normal" }) => {
  const [cardList, setCardList] = useState([]);
  const [loaded, setLoaded] = useState(true);
  const [addCardLoaded, setAddCardLoaded] = useState(true);
  const lang = useSelector((state) => state?.languageSlice?.data);
  const language = localStorage.getItem("language") || lang;
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedForDelete, setSelectedForDelete] = useState(null);
  const [deleteLoaded, setDeleteLoaded] = useState(true);
  const [stripeToken, setStripeToken] = useState(null);
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("userDetails"));

  const languageConfig = {
    addNewCard: {
      en: "Add new card",
      es: "Agregar nueva tarjeta",
      it: "Aggiungi nuova carta",
    },
    addCardLang: {
      en: "Add Card",
      es: "Agregar tarjeta",
      it: "Aggiungi carta",
    },
  };

  const apiKey = STRIPE_API_KEY

  const stripePromise = loadStripe(apiKey);

  useEffect(() => {
    cardList.length === 0 ? setIsCardAvailable(false) : setIsCardAvailable(true);

    if (cardList.length > 0 && !selectedCard) {
      setSelectedCard(cardList[0]);
    }

    let data = userData || {};
    data.cardsDetails = cardList;
    localStorage.setItem("userDetails", JSON.stringify(data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardList, selectedCard]);

  useEffect(() => {
    setLoaded(false);
    fetchCardList().then((res) => {
      setLoaded(true);
      if (res.data.status === 200) {
        setCardList(res.data.data.data);
      } else {
        // (from === "callingModal" || from === "booking") &&
        //   toast.error("No cards found. Please add your debit/credit card.", {
        //     autoClose: 5000,
        //   });
        // navigate("/profile");
      }
    });
  }, []);

  const handleSelect = (e, elm) => {
    setSelectedCard(elm);
  };

  const getCardImage = (brand) => {
    switch (brand) {
      case "american_express":
      case "American Express":
        return americanExpress;
      case "diners_club":
      case "Diners Club":
        return dinersClub;
      case "discover":
      case "Discover":
        return discover;
      case "visa":
      case "Visa":
        return visa;
      case "mastercard":
      case "MasterCard":
        return masterCard;
      case "jcb":
      case "JCB":
        return jcb;
      case "unionpay":
      case "UnionPay":
        return unionPay;
      case "hipercard":
      case "Hipercard":
        return hipercard;
      case "mnp":
      case "MNP":
        return mnp;
      case "elo":
      case "ELO":
        return elo;
      default:
        return troy;
    }
  };

  const handleDelete = () => {
    // Handle the delete action here
    setDeleteLoaded(false);
    selectedForDelete &&
      deleteCardService({ sourceId: selectedForDelete?.id }).then((res) => {
        setDeleteLoaded(true);
        if (res.data.status === 200) {
          let data = cardList.filter((elm) => elm?.id !== selectedForDelete?.id);
          setCardList(data);

          setIsDeleteModalOpen(false);
        }
      });
  };

  const addNewCard = () => {
    if (!stripeToken) {
      toast.error("Please add a card");
      return;
    }
    setAddCardLoaded(false);
    stripeToken &&
      addCardService({ card_token: stripeToken }).then((res) => {
        setAddCardLoaded(true);
        if (res?.data?.status === 200) {
          setCardList((pre) => [...pre, res?.data?.newCardData]);
          toast.success(res?.data?.message);
          setStripeToken(null);
        } else if (res?.data?.status === 400) {
          toast.error(res?.data?.message);
          setStripeToken(null);
        }
      });
  };

  return (
    <>
      {loaded ? (
        <div className="relative my-8 w-full animate-in fade-in slide-in-from-bottom-4 duration-500">
          {isToggle ? (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {cardList.length > 0 &&
                cardList.map((elm, index) => {
                  const isSelected = selectedCard ? (selectedCard.id === elm?.id) : (index === 0);
                  return (
                    <label
                      key={elm?.id || index}
                      className={`group relative flex items-center border rounded-2xl p-5 cursor-pointer transition-all duration-300 ${isSelected ? "border-prontopsy-blue bg-blue-50/30" : "border-neutral-200 bg-white hover:border-neutral-300 hover:shadow-md"
                        }`}
                    >
                      <Radio isChecked={isSelected} radioName={"credit_card"} onChange={(e) => handleSelect(e, elm)} />
                      <div className="w-14 h-10 flex items-center justify-center bg-white rounded-lg border border-neutral-100 shadow-sm mr-2 overflow-hidden p-1">
                        <Image src={getCardImage(elm?.brand)} alt={elm?.brand} className="w-full h-full object-contain" />
                      </div>
                      <div className="flex flex-col">
                        <span className="text-sm font-bold text-neutral-800 tracking-wider capitalize">{elm?.brand}</span>
                        <span className="text-xs text-neutral-500 font-mono italic">{`•••• •••• •••• ${elm?.last4}`}</span>
                      </div>
                      {index === 0 && (
                        <div className="absolute top-2 right-2">
                          <span className="text-[10px] bg-prontopsy-blue text-white px-2 py-0.5 rounded-full font-bold uppercase tracking-tighter">Default</span>
                        </div>
                      )}
                    </label>
                  );
                })}
            </div>
          ) : (
            <div className="space-y-10">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {cardList.length > 0 &&
                  cardList.map((elm) => (
                    <div
                      key={elm?.id}
                      className="group relative bg-gradient-to-br from-neutral-900 to-black rounded-2xl p-6 h-[180px] flex flex-col justify-between shadow-xl transition-all duration-500 hover:-translate-y-1 hover:shadow-black/20 overflow-hidden"
                    >
                      {/* Subtle pattern background */}
                      <div className="absolute inset-0 opacity-10 pointer-events-none">
                        <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none">
                          <path d="M0 100 C 20 0 50 0 100 100 Z" fill="white" />
                        </svg>
                      </div>

                      <div className="flex justify-between items-start relative z-10">
                        <div className="w-14 h-10 bg-white/10 backdrop-blur-md rounded-lg flex items-center justify-center p-2 border border-white/10">
                          <Image
                            src={getCardImage(elm?.brand)}
                            alt={elm?.brand}
                            className="w-full h-full object-contain"
                          />
                        </div>
                        <button
                          className="w-8 h-8 rounded-full bg-red-500/10 text-red-400 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 hover:bg-red-500 hover:text-white"
                          onClick={() => {
                            setSelectedForDelete(elm);
                            setIsDeleteModalOpen(true);
                          }}>
                          <i className="fa-solid fa-trash-can text-sm"></i>
                        </button>
                      </div>

                      <div className="space-y-1 relative z-10">
                        <div className="text-white/40 text-[10px] uppercase tracking-[0.2em] font-bold">Card Number</div>
                        <div className="text-white text-lg font-mono tracking-widest">{`•••• •••• •••• ${elm?.last4}`}</div>
                      </div>

                      <div className="flex justify-between items-end relative z-10">
                        <div className="flex flex-col">
                          <div className="text-white/40 text-[9px] uppercase tracking-widest font-bold">Expires</div>
                          <div className="text-white text-xs font-medium">{elm?.exp_month}/{elm?.exp_year}</div>
                        </div>
                        <div className="uppercase text-[10px] font-black text-white/30 tracking-tighter">{elm?.brand}</div>
                      </div>
                    </div>
                  ))}
              </div>

              <div className="flex items-center gap-3 py-4 px-6 bg-neutral-50 rounded-2xl border border-neutral-100">
                <i className="fa-solid fa-circle-info text-neutral-400"></i>
                <span className="text-xs text-neutral-500 font-medium">
                  {cardList.length > 0 ? appointmentModalLang?.title8?.[language] : appointmentModalLang?.title9?.[language]}
                </span>
              </div>

              <div className="mt-12 group">
                <div className="flex items-center gap-4 mb-8">
                  <div className="h-px flex-1 bg-neutral-200"></div>
                  <h3 className="text-sm font-bold text-neutral-800 uppercase tracking-[0.25em]">
                    {languageConfig?.addNewCard?.[language]}
                  </h3>
                  <div className="h-px flex-1 bg-neutral-200"></div>
                </div>

                <div className="bg-white rounded-3xl border border-neutral-200 p-8 shadow-sm transition-all duration-300 group-focus-within:border-prontopsy-blue group-focus-within:shadow-xl group-focus-within:shadow-prontopsy-blue/5">
                  <div className="mb-6">
                    <Elements stripe={stripePromise} options={{ locale: language }}>
                      <StripeForm setToken={setStripeToken} />
                    </Elements>
                  </div>
                  <Button
                    buttonLabel={languageConfig?.addCardLang?.[language]}
                    buttonLabelClasses={"!text-sm !font-bold !tracking-wide"}
                    buttonClasses={"!w-full !rounded-xl !h-14 !bg-neutral-900 !text-white hover:!bg-black !transition-all !duration-300 shadow-lg hover:shadow-black/20"}
                    buttonFunction={addNewCard}
                    isDisable={!addCardLoaded}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="flex justify-center mt-4 w-full">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-prontopsy-blue"></div>
        </div>
      )}
      <DeleteModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onDelete={handleDelete}
        loaded={deleteLoaded}
      />
    </>
  );
};

export default Cards;
